module.exports = __webpack_public_path__ + "img/search.9da85684.svg";